// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Nl_EL","productName":"Table_productName__5oTv6"};